window.app.directive("ngEnter", [
  function() {
    return {
      restrict: "A",
      scope: false,
      link: function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
          if (event.which === 13) {
            scope.$applyAsync(function() {
              scope.$eval(attrs.ngEnter);
            });

            event.preventDefault();
          }
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/ngEnter.js